@if(isLoading()) {
     @for (item of [].constructor(5); track $index) {
        <div class="container">
            <div class="row">
                <div class="col-lg-6">
                    <ngx-skeleton-loader count="1" appearance="line" [theme]="{ 'height': '100px', 'margin-bottom': '5px', 'width': '98%' }"></ngx-skeleton-loader>
                </div>
                <div class="col-lg-6">
                    <ngx-skeleton-loader count="1" appearance="line" [theme]="{ 'height': '25px', 'margin-bottom': '5px', 'width': '98%' }"></ngx-skeleton-loader>
                    <ngx-skeleton-loader count="1" appearance="line" [theme]="{ 'height': '25px', 'margin-bottom': '5px', 'width': '98%' }"></ngx-skeleton-loader>
                    <ngx-skeleton-loader count="1" appearance="line" [theme]="{ 'height': '25px', 'margin-bottom': '5px', 'width': '50%' }"></ngx-skeleton-loader>
                </div>
            </div>
        </div>
    }
}

@if(!isLoading()){
    @if(articles().length > 0){
        <h5 class="fw-bold pt-0 mt-0">Related Articles</h5>
    }
    @for (obj of articles(); track obj.slug) {
        <div class="container-fluid mb-4">
            <div class="row">
                <div class="col-5 px-0">
                    <div class="thumbnail-sm rounded-2 w-100 bg-white">
                        <a [routerLink]="['/article', obj.categorySlug, obj.slug]">
                            <img [src]="obj.img" [alt]="obj.title" class="object-fit-cover w-100 rounded-2">
                        </a>
                    </div>
                </div>
                <div class="col-7">
                    <h3 class="mt-0 mb-1 inter fs-6 fw-bold lh-base cl-1">
                        <a [routerLink]="['/article', obj.categorySlug, obj.slug]" class="text-dark text-decoration-none" [title]="obj.title">{{obj.title | truncate: 21}}</a>
                    </h3>
                    <p class="inter mb-3 fs-7 cl-2">{{obj.summary | truncate: 47}}</p>
                     <div class="inter fs-8 fw-medium text-secondary">
                        {{obj.minsRead}} min{{obj.minsRead > 0 ? 's' : ''}} read
                     </div>
                </div>
            </div>
        </div>
    }
}